import React from 'react';
import PartnerManagement from '../components/partners/PartnerManagement';

const PartnerView = () => {
    return (
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
            <PartnerManagement />
        </div>
    );
};

export default PartnerView;
